import { validationMessage } from 'vuelidate-messages'
import { messages, validationPass } from '@/lib/validation-helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    formData: {
      entity_id: { required, maxLength: maxLength(255) },
      name: { required },
      type_id: { required }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass: validationPass
  }
}
